
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 21 20","data-token-name":"google-drive-edit"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.227 16.52h5.82m3.136-4.467h-6.4m6.461.03S7.65 2.051 7.41 1.63h5.278l4.503 7.446","stroke":"currentColor","stroke-width":"1.25","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M7.401 1.63l-5.836 10.1 2.662 4.79s5.572-9.769 5.82-10.183m9.557 6.743l-5.45 5.436-2.678.534.536-2.672 5.45-5.436a1.51 1.51 0 012.137 0l.005.006a1.505 1.505 0 010 2.131v0z","stroke":"currentColor","stroke-width":"1.25","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    